import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import PrypysyTab from './views/PrypysyTab.vue'
import MafyTab from './views/MafyTab.vue'
import AdsTab from './views/AdsTab'
import AboutTab from './views/AboutTab'

import store from './store'

Vue.config.productionTip = false


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'prypysy-tab',
    component: PrypysyTab,    
    // component: () => import('./views/PrypysyTab.vue')
  },
  {
    path: '/mafy',
    name: 'mafy-tab',
    component: MafyTab
  },
  {
    path: '/ads',
    name: 'ads-tab',
    component: AdsTab
  },
  {
    path: '/about',
    name: 'about-tab',
    component: AboutTab,
  }

  // {
  //   path: '/mafy',
  //   name: 'Мафи',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  // }
]


const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {
      selector: "#tab"
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#vue-mount')

